import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from '@/plugins/vuetify'
import './components/baseIndex'
import VueMeta from 'vue-meta'

Vue.use(VueMeta, {
    // optional pluginOptions
    refreshOnceOnNavigation: true
})
Vue.config.productionTip = false
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'

Vue.use(Chartkick.use(Chart))
import {Form} from 'vform';

window.Form = Form;

import swal from 'sweetalert2';

window.swal = swal;
const Toast = swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000,
    // onOpen: (toast) => {
    //   toast.addEventListener('mouseenter', swal.stopTimer);
    //   toast.addEventListener('mouseleave', swal.resumeTimer)
    // }
});
window.toast = Toast;
import 'sweetalert2/src/sweetalert2.scss'


import moment from "moment-timezone";

window.moment = moment;
Vue.moment = moment;
import excel from 'vue-excel-export'

Vue.use(excel);


Vue.filter('filterDate', function (myDate) {
    return moment(myDate).format('Do MMMM YYYY, h:mm:ss a');
});

Vue.filter('filterDateOnly', function (myDate) {
    return moment(myDate).format('dddd, MMMM D, YYYY');
});
Vue.filter('filterTime', function (myDate) {
    return moment(myDate).format('hh:mm:ss a');
});


Vue.filter('filterHumanDate', function (myDate) {
    return moment(myDate).fromNow();
});
Vue.filter('filterStDate', function (myDate) {
    return moment(myDate).format('DD.MM.YY,hh:mm');
});
Vue.filter('preciseData', function (x, precision = 2) {
    return Number.parseFloat(x).toFixed(precision);
})
Vue.filter('numberWithCommas', function (x) {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
})
//UPPERCASE TEXT
Vue.filter('uppercaseText', function (text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
});

//-===================
Vue.filter('allUppercase', function (text) {
    return text.toUpperCase()
});
new Vue({
    router,
    vuetify,
    store,
    render: h => h(App)
}).$mount('#app')
